/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      21 February 2024
 */

import VideoContainer from '../../Components/VideoContainer';

const Cosmopolitan = () => {
  return (
    <div className='container max-w-[1920px] pt-8 sm:px-6 xl:px-10 mx-auto'>
      <VideoContainer video='https://www.youtube.com/embed/wZ2QQQ5kQLc' />
      <div className='flex flex-col pt-10'>
        <div className='grid grid-cols-2 gap-2'>
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmo/1_xjdl5i'
            alt=''
            loading='lazy'
          />
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmo/2_prudps'
            alt=''
            loading='lazy'
          />
        </div>
        <img
          className='py-2'
          src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmo/3_mgwo8j'
          alt=''
          loading='lazy'
        />
        <div className='grid grid-cols-2 gap-2'>
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmo/4_dzj6nn'
            alt=''
            loading='lazy'
          />
          <img
            className='h-auto max-w-full'
            src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmo/5_l3iuiu'
            alt=''
            loading='lazy'
          />
        </div>

        <img
          className='py-2'
          src='https://res.cloudinary.com/drawmyqcr/image/upload/f_auto,q_auto/v1/ArtCut/cosmo/6_qkmn1y'
          alt=''
          loading='lazy'
        />
      </div>
    </div>
  );
};
export default Cosmopolitan;
